import { useEffect } from 'react';

type Props = {
  callback: () => void;
};

const useGlobalKeyDown = ({ callback }: Props) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // check if the key combination is command + ctrl + a
      if (event.metaKey && event.ctrlKey && event.key.toLowerCase() === 'a') {
        event.preventDefault();
        callback();
      }
    };

    // Add the event listener
    window.addEventListener('keydown', handleKeyDown);

    // Clean up the event listener
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback]);

  return {};
};

export default useGlobalKeyDown;
